import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Calendar, Badge  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';



import moment from 'moment'
import Getteachet2 from './Getteachet2';
import Getprograme from './Getprograme';
import Modalpayedit from './Modalpayedit';
moment.updateLocale('en', {
  weekdaysMin : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
});



export default class Reporttess extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          prenm:'',
          term:'',
          type:'',

          poname:'',
          typename:'ยังไม่ระบุ',
         
        };
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.getListData = this.getListData.bind(this);
        this.dateCellRender = this.dateCellRender.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
        this.sentpdf2 = this.sentpdf2.bind(this);
        this.sentpdf3 = this.sentpdf3.bind(this);
        this.sentpdf4 = this.sentpdf4.bind(this);
        this.sentpdf5 = this.sentpdf5.bind(this);
        this.sentpdf6 = this.sentpdf6.bind(this);
        this.sentpdf8 = this.sentpdf8.bind(this);
        this.updateSearchtype = this.updateSearchtype.bind(this);
        this.sentpdfcover = this.sentpdfcover.bind(this);

        this.sentpdflearn = this.sentpdflearn.bind(this);
        this.sentpdflearn2 = this.sentpdflearn2.bind(this);
        this.sentpdflearn3= this.sentpdflearn3.bind(this);
        this.sentpdflearn4 = this.sentpdflearn4.bind(this);
        this.sentpdflearn5 = this.sentpdflearn5.bind(this);
        this.sentpdflearn6 = this.sentpdflearn6.bind(this);
        this.sentpdflearn8 = this.sentpdflearn8.bind(this);

      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
          //  setTimeout(() => {
          //    this.getthschedule()
          //  }, 500);
    }



    sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=1', '_blank');
         // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=1', '_blank');
         }, 0);
    }

    sentpdf2() {
      setTimeout(() => {
       // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=2', '_blank');
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=2', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport.php?term='+this.state.term+'&type='+this.state.type+'&faculty=2', '_blank');
       }, 0);
    }

    sentpdf3() {
    setTimeout(() => {
    //  window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=3', '_blank');
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=3', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport.php?term='+this.state.term+'&type='+this.state.type+'&faculty=3', '_blank');
     }, 0);
    }

    sentpdf4() {
    setTimeout(() => {
    //  window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=4', '_blank');
      window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=4', '_blank');
      // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport.php?term='+this.state.term+'&type='+this.state.type+'&faculty=4', '_blank');
     }, 0);
    }

    sentpdf5() {
    setTimeout(() => {
    //  window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=5', '_blank');
      window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=5', '_blank');
      // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport.php?term='+this.state.term+'&type='+this.state.type+'&faculty=5', '_blank');
     }, 0);
    }

    sentpdf6() {
      setTimeout(() => {
       // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=6', '_blank');
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=6', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport.php?term='+this.state.term+'&type='+this.state.type+'&faculty=6', '_blank');
      
      }, 0);
    }

   sentpdf8() {
    setTimeout(() => {
     // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport2.php?term='+this.state.term+'&type='+this.state.type+'&faculty=8', '_blank');
      window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreport3.php?term='+this.state.term+'&type='+this.state.type+'&faculty=8', '_blank');
      // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreport.php?term='+this.state.term+'&type='+this.state.type+'&faculty=8', '_blank');
     
     }, 0);
   }





   //ปก
    sentpdfcover() {
      setTimeout(() => {
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesscover.php?term='+this.state.term+'&type='+this.state.type+'&faculty=1', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesscover.php?term='+this.state.term+'&type='+this.state.type+'&faculty=1', '_blank');
       
       }, 0);
    }


    //ตารางเรียนคณะวิทยาศาสตร์
    sentpdflearn() {
      setTimeout(() => {
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=1', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=1', '_blank');
       
       }, 0);
    }

    
    //ตารางเรียนคณะครุศาสตร์
    sentpdflearn2() {
      setTimeout(() => {
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=2', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=2', '_blank');
       
       }, 0);
    }

      //ตารางเรียนคณะมนุษยศาสตร์และสังคมศาสตร์
    sentpdflearn3() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=3', '_blank');
          // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=3', '_blank');

         }, 0);
    }

    //ตารางเรียนคณะวิทยาการจัดการ
    sentpdflearn4() {
      setTimeout(() => {
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=4', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=4', '_blank');
      }, 0);
    }

    //ตารางเรียนคณะเทคโนโลยีอุตสาหกรรม
    sentpdflearn5() {
      setTimeout(() => {
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=5', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=5', '_blank');
      }, 0);
    }

    //ตารางเรียนมหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด
    sentpdflearn6() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=6', '_blank');
          // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=6', '_blank');
        }, 0);
    }

     //ตารางเรียนคณะพยาบาลศาสตร์
    sentpdflearn8() {
      setTimeout(() => {
        window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=8', '_blank');
        // window.open('http://localhost/tesspdf/TCPDF-main/tesslearnreportlearn.php?term='+this.state.term+'&type='+this.state.type+'&faculty=8', '_blank');
       
      }, 0);
    }

  
      
    updateSearchtype(value) {
      // console.log(event.target.value)
      // const term = event.target.value;
      const type = value;
      this.setState({ type });
        //  setTimeout(() => {
        //    this.getthschedule()
        //  }, 500);
      if (type == 1) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร' });
      }
      if (type == 2) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร' });
      }
      if (type == 3) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร แม่สอด' });
      }
      if (type == 5) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร แม่สอด' });
      }

    }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthschedulesearch/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      getteachingschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showteachingschedule/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ showteachingschedule: res.data})

             if (res.data.length !== 0) {
               const teacher = res.data[0].poname;
             //  const prenm = res.data[0].prenm;
               this.setState({ teacher });
             //  this.setState({ prenm });
             }
             
           }) 
         }, 0);
      }

   

      onChange(value) {
          console.log(`selected ${value}`);
          const idemp = value;
          this.setState({ idemp });


          const teachersearcha = this.state.thschedule.filter( ({ user_teacher }) => user_teacher === idemp );
          this.setState({ poname : teachersearcha[0].poname});
          this.setState({ prenm : teachersearcha[0].prenm});


        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck: res.data})
        //     }) 
        //   }, 0);

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck2: res.data})
        //     }) 
        //   }, 0);
          setTimeout(() => {
            this.getteachingschedule()
          }, 500);
     }


         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          
           getListData(value) {
             let listData;
             this.state.showteachingschedule.map((showteachingschedule) => {
             // let daysum = Number(showteachingschedule.ss)
              //  for (let  index = 0; index < 5; index++) {
              //       daysum = daysum + 7;
              //       if (value.week() === daysum) {
              //        listData = [
              //               { type: 'warning', content: 'This is warning event.' },
              //               { type: 'success', content: 'This is usual event.' },
              //             ];
              //      }
              //  }

               if (value.weekdaysMin() === "Sun") {
                listData = [
                       { type: 'warning', content: 'This is warning event.' },
                       { type: 'success', content: 'This is usual event.' },
                     ];
               }
             
            //  <>{showteachingschedule.ss}  </>  
            return listData || [];
             });


            // let listData = this.state.showteachingschedule.map((showteachingschedule) =>
            
            // <li key={showteachingschedule.toString()}> {showteachingschedule.ss} </li>
            // );
           //  let  lissd = 'sds';
           //  let  lisd =  this.state.showteachingschedule.map((showteachingschedule) =>  <>{showteachingschedule.ss}  </>  );
          

         //console.log('dddd'+lissd);
        
     
          //   switch (value.date()) {
          
          //      case 5:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //       ];
          //       break;
          //     case 7:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //       ];
          //       break;
          //     case 10:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //         { type: 'error', content: 'This is error event.' },
          //       ];
          //       break;
          //     case 15:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event' },
          //         { type: 'success', content: 'This is very long usual event。。....' },
          //         { type: 'error', content: 'This is error event 1.' },
          //         { type: 'error', content: 'This is error event 2.' },
          //         { type: 'error', content: 'This is error event 3.' },
          //         { type: 'error', content: 'This is error event 4.' },
          //       ];
          //       break;
          //     default:
          //   }
             return listData || [];
           }


           dateCellRender(value) {
            const listData = this.getListData(value);
            return (
              <ul className="events">
                {listData.map(item => (
                  <li key={item.content}>
                    <Badge status={item.type} text={item.content} />
                  </li>
                ))}
              </ul>
            );
           }
          
           getMonthData(value) {
            if (value.month() === 8) {
              return 1394;
            }
           }
          
           monthCellRender(value) {
            const num = this.getMonthData(value);
            return num ? (
              <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
              </div>
            ) : null;
          }
          


    render() {

      console.log(this.state.type)
      console.log(this.state.term)
      

        const { Option } = Select;
        const online = window.navigator.onLine;
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )     
      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }
      

      //ปฏิทิน



     


        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางสอน</h4>
                </MDBAlert>
     <br/> */}
      <Card type="inner"  title={<h4 className="unique-text"><MDBIcon icon="book" /> รายงานตารางเรียน-สอน แบบเล่ม</h4>} >

      


    <MDBRow>
           
            <MDBCol sm="4">
              <p>เลือกภาคเรียน</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.term}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564">1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                            <Option value="1/2565">1/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option value="2/2566">2/2566</Option>
                            <Option ative value="3/2566">3/2566</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option value="2/2567">2/2567</Option>
                            <Option ative value="3/2567">3/2567</Option>
                            <Option value="1/2568">1/2568</Option>
                            <Option value="2/2568">2/2568</Option>
                            <Option value="3/2568">3/2568</Option>
                             <Option value="1/2569">1/2569</Option>
                            <Option value="2/2569">2/2569</Option>
                            <Option value="3/2569">3/2569</Option>

                        </Select>
                    </div>
                    {/* <br/> */}

            </MDBCol>
            
            <MDBCol sm="8">
              <p>เลือกประเภทนักศึกษา</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกประเภทนักศึกษา"
                            optionFilterProp="children"
                            onChange={this.updateSearchtype}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.type}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option value="1">ปกติกำแพงเพชร</Option>
                            <Option value="2">กศ.บป.กำแพงเพชร</Option>
                            <Option value="3">กศ.บป.กำแพงเพชร แม่สอด</Option>
                            <Option value="5">ปกติกำแพงเพชร แม่สอด</Option>
                           
                        </Select>
                    </div>
                    {/* <br/> */}

            </MDBCol>

           
  </MDBRow>

                {/* { this.state.empcouncilcheck.length === 0 ? <> </> : 
                <>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันอังคาร ของทุกเดือน
                </MDBAlert>
                </>}

                { this.state.empcouncilcheck2.length === 0 ? <> </> : 
                <>
                <MDBAlert color="warning ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันพฤหัสบดี ของทุกเดือน
                </MDBAlert>
                </>} */}

          { this.state.type === '' ? <></> :<> 
          <br/>
          <hr/>
          <MDBAlert color="success">
          <h5 className="text-center">รายงานตารางเรียน-สอน </h5> 
           <h5 className="text-center">ภาคเรียนที่ {this.state.term}</h5> 
           <h5 className="text-center"> {this.state.typename}</h5> 
          </MDBAlert>
       
           
          {this.state.poname === ''?<></>:<>  <h5 className="text-center">{this.state.prenm}{this.state.poname} </h5>  <MDBBtn color="primary" size="sm" onClick={this.sentpdf}><MDBIcon far icon="file-pdf" /> พิมพ์</MDBBtn></> }
          {this.state.empcouncil === '' ? <>
          <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            </>: <>
            <h6 className="text-center">ตารางเรียน</h6> 
            <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1">

                <tr>
                    <th  className="text-center">ลำดับ</th>
                    <th  className="text-center">รายการ</th>
                    <th  className="text-center">จัดการ</th>
                </tr>

                </MDBTableHead>

                <MDBTableBody>
                          <tr>
                          <td  className="text-center">1</td>
                          <td>หน้าปก</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdfcover} >พิมพ์</MDBBtn></td>
                          </tr>

                          <tr>
                          <td  className="text-center">2</td>
                          <td>ตารางเรียนคณะวิทยาศาสตร์และเทคโนโลยี</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn} >พิมพ์</MDBBtn></td>
                          </tr>
                         
                          <tr>
                          <td  className="text-center">3</td>
                          <td>ตารางเรียนคณะครุศาสตร์</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn2} >พิมพ์</MDBBtn></td>
                          </tr>

                          <tr>
                          <td  className="text-center">4</td>
                          <td>ตารางเรียนคณะมนุษยศาสตร์และสังคมศาสตร์</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn3} >พิมพ์</MDBBtn></td>
                          </tr>

                          <tr>
                          <td  className="text-center">5</td>
                          <td>ตารางเรียนคณะวิทยาการจัดการ</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn4} >พิมพ์</MDBBtn></td>
                          </tr>

                          <tr>
                          <td  className="text-center">6</td>
                          <td>ตารางเรียนคณะเทคโนโลยีอุตสาหกรรม</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn5} >พิมพ์</MDBBtn></td>
                          </tr>

                          <tr>
                          <td  className="text-center">7</td>
                          <td>ตารางเรียนมหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn6} >พิมพ์</MDBBtn></td>
                          </tr>

                          <tr>
                          <td  className="text-center">8</td>
                          <td>ตารางเรียนคณะพยาบาลศาสตร์</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdflearn8} >พิมพ์</MDBBtn></td>
                          </tr>
               
                </MDBTableBody>
            </MDBTable>

            <h6 className="text-center">ตารางสอน</h6> 
            <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1">

                <tr>
                    <th  className="text-center">ลำดับ</th>
                    <th  className="text-center">รายการ</th>
                    <th  className="text-center">จัดการ</th>
                </tr>

                </MDBTableHead>

                <MDBTableBody>
                        
                          <tr>
                          <td  className="text-center">1</td>
                          <td>ตารางสอนคณะวิทยาศาสตร์และเทคโนโลยี</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf} >พิมพ์</MDBBtn></td>
                          </tr>
                          <tr>
                          <td  className="text-center">2</td>
                          <td>ตารางสอนคณะครุศาสตร์</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf2} >พิมพ์</MDBBtn></td>
                          </tr>
                          <tr>
                          <td  className="text-center">3</td>
                          <td>ตารางสอนคณะมนุษยศาสตร์และสังคมศาสตร์</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf3} >พิมพ์</MDBBtn></td>
                          </tr>
                          <tr>
                          <td  className="text-center">4</td>
                          <td>ตารางสอนคณะวิทยาการจัดการ</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf4} >พิมพ์</MDBBtn></td>
                          </tr>
                          <tr>
                          <td  className="text-center">5</td>
                          <td>ตารางสอนคณะเทคโนโลยีอุตสาหกรรม</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf5} >พิมพ์</MDBBtn></td>
                          </tr>
                          <tr>
                          <td  className="text-center">6</td>
                          <td>ตารางสอนมหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf6} >พิมพ์</MDBBtn></td>
                          </tr>
                          <tr>
                          <td  className="text-center">7</td>
                          <td>ตารางสอนคณะพยาบาลศาสตร์</td>
                          <td className="text-center"><MDBBtn color="unique" size="sm" onClick={this.sentpdf8} >พิมพ์</MDBBtn></td>
                          </tr>
               
                </MDBTableBody>
            </MDBTable>
            {/* <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1">

                <tr>
                    <th  className="text-center">ลำดับ</th>
                    <th  className="text-center">รายการ</th>
                    <th  className="text-center">จัดการ</th>
                </tr>

                </MDBTableHead>
                <MDBTableBody>

                          <tr>
                          <td>1</td>
                          <td>{ this.state.type === '1' ?<>ตารางเรียน-สอน ภาคปกติกำแพงเพชร </> :<> </> }
                              { this.state.type === '2' ?<>ตารางเรียน-สอน กศ.บป.กำแพงเพชร </> :<> </> }
                              { this.state.type === '3' ?<>ตารางเรียน-สอน กศ.บป.กำแพงเพชร แม่สอด </> :<> </> }
                              { this.state.type === '5' ?<>ตารางเรียน-สอน ปกติกำแพงเพชร แม่สอด </> :<> </> }
                          </td>
                          <td className="text-center"><MDBBtn color="unique" onClick={this.sentpdf} >รายงาน</MDBBtn></td>
                          </tr>
               
                </MDBTableBody>
            </MDBTable> */}
            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
        </>}

        </Card>

        {/* <Calendar dateCellRender={this.dateCellRender} monthCellRender={this.monthCellRender} />, */}
            </MDBContainer>

        )
    }
}
